import { createChildActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

const entityName = entityNames.rfqs
const childName = 'rfqSuppliers'

export default createChildActions(entityName, childName)
